module.exports = __webpack_public_path__ + "static/media/homework-completion-screen-footer.b6edd9f1.png";